import React from 'react';
export function About() {
  return <section className="py-16 bg-gray-50" data-id="element-26">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-27">
        <div className="grid md:grid-cols-2 gap-12 items-center mb-8" data-id="element-28">
          {/* Text Content */}
          <div data-id="element-29">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6" data-id="element-30">
              About Sam's Disposal
            </h2>
            <div className="space-y-4" data-id="element-31">
              <p className="text-lg text-gray-700 leading-relaxed" data-id="element-32">
                Sam's Disposal is local, reliable, and family-owned, proudly
                serving Mecosta, Osceola, Newaygo, and Montcalm Counties since
                1989. We're your neighbors — not a national chain — which means
                simple pricing, no hidden fees, and real people who care.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed" data-id="element-33">
                Founded on principles of integrity and hard work, we've grown
                into a trusted waste management provider throughout the region.
                Today, we maintain modern equipment, employ professional
                drivers, and provide dependable on-time pickups that our
                customers count on.
              </p>
            </div>
          </div>
          {/* Truck Image */}
          <div className="flex justify-center md:justify-end" data-id="element-34">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/bdK7KkVV6y7sncjsNLF2BP/484518607_1163770195543842_5052838154180650984_n.jpg" alt="Sam's Disposal truck" className="w-full max-w-lg h-auto object-contain" data-id="element-35" />
          </div>
        </div>
        {/* Centered Button */}
        <div className="flex justify-center" data-id="element-36">
          <button className="bg-[#E41C1C] text-white font-bold px-8 py-4 rounded hover:bg-red-700 transition-colors text-lg shadow-lg" data-id="element-37">
            More About Sam's Disposal
          </button>
        </div>
      </div>
    </section>;
}